import { render, staticRenderFns } from "./WidgetPageButtonLayout.vue?vue&type=template&id=789581e2&scoped=true&"
import script from "./WidgetPageButtonLayout.vue?vue&type=script&lang=js&"
export * from "./WidgetPageButtonLayout.vue?vue&type=script&lang=js&"
import style0 from "./WidgetPageButtonLayout.vue?vue&type=style&index=0&id=789581e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789581e2",
  null
  
)

export default component.exports